import { FeaturesDisplayLayoutUI } from './FeaturesDisplayLayoutUI';
import { PriorityFeatures } from './PriorityFeatures';
import { jsx as _jsx } from "react/jsx-runtime";
export const UncategorizedPriorityFeatures = ({
  uncategorizedFeatures,
  isCollapsible = false,
  lowerTierMessage
}) => {
  const FeaturesListSection = /*#__PURE__*/_jsx(PriorityFeatures, {
    features: uncategorizedFeatures
  });
  return /*#__PURE__*/_jsx(FeaturesDisplayLayoutUI, {
    HeaderSection: lowerTierMessage || undefined,
    FeaturesListSection: FeaturesListSection,
    isCollapsible: isCollapsible
  });
};